export default __webpack_public_path__ + "static/media/icon-Hub-Overview.52a78ade.svg";